<template>
  <div class="tree-list">
    <div
      v-for="item in formatData"
      :key="item[props.value]"
      class="tree-list__item"
    >
      <div
        class="tree-list__item-line"
        :class="{'tree-list__item-line-checked':chcekedItem[props.value] === item[props.value], 'disabled': getDisabled(item)}"
        @click="handleItemClick(item)"
      >
        <feather-icon
          :icon="item[props.children] ? (item.EXPAND ? 'FolderMinusIcon' : 'FolderPlusIcon') : 'FolderIcon'"
          class="placeholder-icon"
          :class="{'cursor-pointer':item[props.children]}"
          size="20"
          @click.stop="item.EXPAND = !item.EXPAND"
        />
        <span class="tree-list__item-label">{{ item[props.label] }}</span>
      </div>

      <div
        v-if="item[props.children]"
        :class="item.EXPAND ? 'is-expand' : 'not-expand'"
        class="tree-list__item-children"
      >
        <tree-list
          ref="treeListChildren"
          :data="item[props.children]"
          :props="(props.props ? props.props : props)"
          :handle-disabled="(r => getDisabled(r))"
          @checkItem="handleItemClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeList',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    props: {
      type: Object,
      default: () => ({
        label: 'label',
        value: 'value',
        children: 'children',
      }),
    },
    expand: {
      type: Boolean,
      default: true,
    },
    handleDisabled: {
      type: Function,
      default: () => false,
    },
  },
  data() {
    return {
      formatData: [],
      chcekedItem: {},
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(e) {
        if (this.expand) {
          const temp = []
          e.forEach(item => {
            const param = { ...item }
            param.EXPAND = true
            temp.push(param)
          });
          this.formatData = temp
        }
      },
    },
  },
  mounted() {

  },
  methods: {
    handleItemClick(e) {
      if (this.getDisabled(e)) {
        return
      }
      const items = this.$refs.treeListChildren || []
      items.forEach(o => { o.clearChecked() })
      setTimeout(() => {
        this.chcekedItem = e
      }, 10);
      const param = { ...e }
      delete param.EXPAND
      this.$emit('checkItem', param)
    },
    clearChecked() {
      this.chcekedItem = {}
    },
    getDisabled(e) {
      return this.handleDisabled(e)
    },
  },
}
</script>

<style lang="scss" scoped>
.tree-list{
    &__item{
        &-children{
            padding-left: 20px;
        }
        &-label{
            display: inline-block;
            transform: translateY(3px);
            margin-left: 5px;
        }
        &-line{
            border-radius: 5px;
            &:hover, &-checked{
                background-color: #EEE;
                cursor: pointer;
                .tree-list__item-label{
                    color: #409EFF;
                }
            }
        }
        .disabled{
          cursor:not-allowed;
          &:hover{
              background-color: transparent;
              .tree-list__item-label{
                  color: #000;
              }
          }
        }
    }
    .tree-list__item-children{
        transition: auto .3s;
        overflow: hidden;
        .tree-list__item{
            position: relative;
            &::after{
                content: '';
                position: absolute;
                left: -10px;
                top: 0;
                height: 100%;
                width: 1px;
                background-color: #ccc;
            }
        }
        .tree-list__item-line{
            position: relative;
            &::before{
                content: '';
                position: absolute;
                left: -10px;
                top: 50%;
                height: 1px;
                width: 10px;
                background-color: #666;
            }
        }
    }
    .tree-list__item-children{
        .tree-list__item:last-child{
            &::after{
                height: 50%;
            }
        }
    }
    .not-expand{
        height: 0;
    }
    .is-expand{
        height: auto;
    }
}
</style>
